module.exports = __webpack_public_path__ + "img/twitter.05235705.png";